import { useState } from 'react'
import { getBrand } from 'config/brand'

/**
 * The 52px brand bar: the partner's logo and nothing else. With no logo in the
 * session or the deployment's config, the brand name; with neither, an empty bar.
 * Nothing here is allowed to fall back to Kit19 on its own — partners resell this.
 */
export default function TopBar() {
  const brand = getBrand()
  const [logo, setLogo] = useState(brand.logo)

  return (
    <header className="k-topbar">
      {logo ? (
        <div className="k-topbar-logo">
          <img src={logo} alt={brand.name} onError={() => setLogo('')} />
        </div>
      ) : brand.name ? (
        <span className="k-topbar-brand">{brand.name}</span>
      ) : null}
    </header>
  )
}
